export default {
  'apiConnectionGroup.title': 'Manage Api Connection Group',

  'apiConnectionGroup.form.id': 'ID',
  'apiConnectionGroup.form.enable': 'Enabled',
  'apiConnectionGroup.form.name': 'Name',
  'apiConnectionGroup.form.description': 'Description',

  'apiConnectionGroup.form.statusLabel': 'Is Enabled?',

  'apiConnectionGroup.enabled': 'Enabled',
  'apiConnectionGroup.disabled': 'Disabled',
  'apiConnectionGroup.apiConnection': 'Api Connection',
};
